import request from '@/utils/requset'

// 登录
export function login(data) {
  return request({
    url: `api/auth/login`,
    method: 'post',
    data
  })
}

// 分类(课本、模型)
export function category() {
  return request({
    url: `api/textbook/category`,
    method: 'get'
  })
}

// 获取课本列表
export function textbooks(data) {
  return request({
    url: `api/textbook/getLists`,
    method: 'get',
    params: data
  })
}

// 获取教具列表
export function tools(data) {
  return request({
    url: `api/tools/lists`,
    method: 'post',
    data
  })
}

// 获取实验列表
export function experiments(data) {
  return request({
    url: `api/experiments/lists`,
    method: 'post',
    data
  })
}

// 获取模型列表
export function models(data) {
  return request({
    url: `api/models/lists`,
    method: 'post',
    data
  })
}

// 用户信息
export function userInfo() {
  return request({
    url: `api/user/info`,
    method: 'GET'
  })
}

// vip账户注册/登录
export function loginVIP(userName, name) {
  return request({
    url: `api/vip/vipLogin`,
    method: 'POST',
    data: { userName, name }
  })
}
